export const headers = () => {
    const token = localStorage.getItem('authToken');

    return {
        'x-timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        'Authorization': `Bearer ${token}`
    };
}
